'use client'

import { useContext } from 'react'

import DropOffPointMapContext from './DropOffPointMapContext'

const useDropOffPointMapContext = () => {
  const context = useContext(DropOffPointMapContext)

  if (!context) {
    throw new Error('useDropOffPointMapContext must be used within a DropOffPointMapContext')
  }

  return context
}

export default useDropOffPointMapContext
